export enum CssPropertiesValues {
  Absolute = 'absolute',
  Auto = 'auto',
  Hidden = 'hidden',
}
